// extracted by mini-css-extract-plugin
export default {"tabs":"GlossaryList_tabs__Pur1g","tab":"GlossaryList_tab__l+pJw","tab--active":"GlossaryList_tab--active__nxXvj"};